<template>
    <div class="loading-spinner">
      <div class="content">
        <div class="spinner"></div>
      </div>
    </div>
  </template>

  <script>
  </script>

  <style scoped>
  .loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30rem;
  }

  .content {
    text-align: center;
  }


  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    align-items: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  </style>
